import React from "react";
import { Button, Banner, Text, Box } from "@shopify/polaris";
import PageHelmet from "components/PageHelmet";
import AuthContainer from "../../AuthContainer";
import SignUpStep1 from "./SignUpStep1";
import SignUpStep2 from "./SignUpStep2";
import useSignUpPage from "../../shared/hooks/useSignUpPage";

export default function SignUpPage() {
  const {
    t,
    navigate,
    step,
    email,
    errorEmail,
    name,
    errorName,
    surname,
    errorSurname,
    companyName,
    errorCompanyName,
    errorCountry,
    referralToken,
    selectedCategories,
    selectedApp,
    registerProjectError,
    registered,
    registering,
    registerError,
    countries,
    sent,
    inviteErrorMessage,
    recaptchaSitekey,
    setStep,
    isCategoryChecked,
    handleCategoryChange,
    doResendEmail,
    validateEmail,
    handleChange,
    handleChangeCountry,
    handleAppSelect,
    handleNextStep,
    doSignup,
    onRecaptchaChange,
    onRecaptchaExpired,
  } = useSignUpPage();

  const renderSuccess = () => (
    <Box padding="4" maxWidth="500px">
      <Text variant="headingLg" as="h2">
        {t("signUp.finishReg")}
      </Text>
      <p>
        {t("signUp.weSent1")}{" "}
        <a href="" onClick={doResendEmail}>
          {t("signUp.weSent2")}
        </a>
        .
      </p>
      {sent && (
        <Banner
          title="New email has been successfully sent."
          tone="success"
        />
      )}
    </Box>
  );

  const renderSignUpForm = () => {
    if (step === 1) {
      return (
        <SignUpStep1
          t={t}
          countries={countries}
          email={email}
          errorEmail={errorEmail}
          name={name}
          errorName={errorName}
          surname={surname}
          errorSurname={errorSurname}
          companyName={companyName}
          errorCompanyName={errorCompanyName}
          errorCountry={errorCountry}
          referral_token={referralToken}
          registering={registering}
          onChange={handleChange}
          onChangeCountry={handleChangeCountry}
          onValidateEmail={validateEmail}
          onNext={handleNextStep}
          inviteErrorMessage={inviteErrorMessage}
        />
      );
    }

    return (
      <SignUpStep2
        t={t}
        selectedCategories={selectedCategories}
        isCategoryChecked={isCategoryChecked}
        onCategoryChange={handleCategoryChange}
        registering={registering}
        onSubmit={doSignup}
        onBack={() => setStep(1)}
        onRecaptchaChange={onRecaptchaChange}
        onRecaptchaExpired={onRecaptchaExpired}
        registerError={registerError}
        recaptchaSitekey={recaptchaSitekey}
        selectedApp={selectedApp}
        onAppSelect={handleAppSelect}
        registerProjectError={registerProjectError}
      />
    );
  };

  return (
    <>
      <PageHelmet title="Sign Up" />
      <AuthContainer
        title="Sign Up"
        description="Easily manage taxes in EU or USA"
        content={registered ? renderSuccess() : renderSignUpForm()}
        secondaryContent={
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              width: "100%",
              alignItems: "center",
            }}
          >
            <Text color="subdued">Already have an account ?</Text>
            <div style={{ width: "100px", marginLeft: 20 }}>
              <Button onClick={() => navigate("/login")}>Log in</Button>
            </div>
          </div>
        }
      />
    </>
  );
}
